import { useIntl } from 'react-intl';

import { useSearchContext } from './search-provider';

const MAX_SEARCH_RESULT_COUNT = 10_000_000;

export const useLimitedSearchCount = (): string => {
  const { count } = useSearchContext();
  const { formatNumber } = useIntl();

  const limitedSearchResultCount =
    count > MAX_SEARCH_RESULT_COUNT
      ? `${formatNumber(MAX_SEARCH_RESULT_COUNT)}+`
      : formatNumber(count);

  return limitedSearchResultCount;
};
